// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeController_inputRoot__tpuYS","arrowIcon":"DateRangeController_arrowIcon__3PL_v"};